/*
Copyright 2024 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-NevaiMeet-Commercial
Please see LICENSE in the repository root for full details.
*/

import { useEffect } from "react";

import {
  focusOutline,
  largerTapTargets,
  reduceMotion,
} from "../meet/MeetSettings";

export function applyAccessibilityClasses(): void {
  const root = document.documentElement;
  root.classList.toggle("nevai-reduce-motion", reduceMotion.getValue());
  root.classList.toggle("nevai-large-tap", largerTapTargets.getValue());
  root.classList.toggle("nevai-focus-outline", focusOutline.getValue());
}

export function useAccessibility(): void {
  useEffect(() => {
    applyAccessibilityClasses();
    const subs = [
      reduceMotion.value$.subscribe(applyAccessibilityClasses),
      largerTapTargets.value$.subscribe(applyAccessibilityClasses),
      focusOutline.value$.subscribe(applyAccessibilityClasses),
    ];
    return () => subs.forEach((s) => s.unsubscribe());
  }, []);
}
